import { T } from "./content";
import { scrollToId } from "./hooks";

export default function Intro({ lang }) {
  const t = T[lang];
  const go = (id) => scrollToId(id);
  return (
    <section className="section intro" data-testid="section-intro">
      <div className="container intro__inner">
        <p className="lead intro__lead reveal">{t.heroLead}</p>
        <div className="intro__ctas reveal">
          <button className="btn btn--solid" onClick={() => go("univers")} data-testid="cta-univers">
            <span>{t.ctaUnivers}</span>
          </button>
          <button className="btn" onClick={() => go("maison")} data-testid="cta-manifeste">
            <span>{t.ctaManifeste}</span>
          </button>
          <button className="btn" onClick={() => go("galerie")} data-testid="cta-galerie">
            <span>{t.ctaGalerie}</span>
          </button>
        </div>
      </div>
    </section>
  );
}
